/**
 * Shared styles for credential sections
 * Matching legacy app.less styling
 */

/** Label color matches legacy `.labelz { color: #54698d }` */
export const labelSx = { fontSize: '13px', fontWeight: 'normal', mb: 0.25, color: '#54698d' };
export const helperSx = { fontSize: '11px', color: '#888', mt: 0.25 };

/** Field width 300px matches legacy .form-control { width: 300px } */
export const inputSx = {
  width: 300,
  maxWidth: '100%',
  '& .MuiInputBase-input': { fontSize: '13px', py: '6px', px: '12px' },
  '& .MuiOutlinedInput-root': { borderRadius: '4px' },
};

/** Wider field width for URLs and long credentials */
export const wideInputSx = {
  width: 500,
  maxWidth: '100%',
  '& .MuiInputBase-input': { fontSize: '13px', py: '6px', px: '12px' },
  '& .MuiOutlinedInput-root': { borderRadius: '4px' },
};

/** OAuth-style button matching legacy wizard Button type="brand" */
export const oauthBtnSx = {
  textTransform: 'none' as const,
  fontSize: '13px',
  py: 0.5,
  px: 2,
  bgcolor: '#00853E',
  color: 'white',
  '&:hover': { bgcolor: '#006d33' },
};
